/* RESPONSIBLE TEAM: team-messenger */
import EmbercomAdapter from 'embercom/lib/adapter/embercom-adapter';

export default class OfficeHoursExceptionAdapter extends EmbercomAdapter {
  buildURL(
    _modelName: any,
    id?: string | number | null,
    snapshot?: any,
    requestType?: string,
  ): string {
    let scheduleId = snapshot?.adapterOptions?.scheduleId;

    if (!scheduleId) {
      throw new Error('scheduleId must be provided in adapterOptions');
    }

    let baseUrl = `/ember/office_hours_schedules/${scheduleId}/office_hours_exceptions`;

    if (id && ['findRecord', 'updateRecord', 'deleteRecord'].includes(requestType || '')) {
      return `${baseUrl}/${id}`;
    }

    return baseUrl;
  }
}
